import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CameraFacialComponent, ModoCameraFacial } from '../../shared/camera-facial.component';
import { CaixaFaceDetectada } from '../../shared/servico-reconhecimento-facial';

@Component({
  selector: 'app-painel-camera-registro',
  standalone: true,
  imports: [CommonModule, CameraFacialComponent],
  templateUrl: './painel-camera-registro.component.html'
})
export class PainelCameraRegistroComponent {
  @Input() ativa = false;
  @Input() modo: ModoCameraFacial = 'registro';
  @Input() margemSuperior = false;
  @Input() rostoDetectado = false;
  @Input() provaVidaOk = false;
  @Input() capturando = false;
  @Input() mensagem = '';
  @Input() caixaFace?: CaixaFaceDetectada;
  @Input() zoomVisual = 1;

  @Output() confirmar = new EventEmitter<void>();
}
